import { regions, countries } from '@/configuration/regions'

let gatewayCsvHeaders = {
  eui: {
    required: true,
    format: 'a-gatewaysImport:bulk.eui',
    length: 16
  },
  fleetId: {
    required: true,
    format: 'a-gatewaysImport:bulk.fleetId'
  },
  name: {
    format: 'a-gatewaysImport:bulk.name',
    maxLength: 255
  },
  brandId: {
    required: true,
    values: ['CISCO', 'KERLINK', 'MULTITECH', 'TEKTELIC'],
    format: 'a-gatewaysImport:bulk.brandId'
  },
  region: {
    required: true,
    values: regions,
    format: 'a-gatewaysImport:bulk.region'
  },
  country: {
    required: false,
    values: countries,
    format: 'a-gatewaysImport:bulk.country'
  },
  visibility: {
    required: true,
    values: ['PRIVATE', 'PUBLIC'],
    format: 'a-gatewaysImport:bulk.visibility'
  },
  ip: {
    format: 'a-gatewaysImport:bulk.ip',
    maxLength: 15
  },
  port: {
    format: 'a-gatewaysImport:bulk.port'
  },
  gpsPositionAllowed: {
    format: 'a-gatewaysImport:bulk.gpsPositionAllowed'
  },
  dlAllowed: {
    required: true,
    format: 'a-gatewaysImport:bulk.dlAllowed'
  },
  adaptiveLatencyEnabled: {
    required: true,
    format: 'a-gatewaysImport:bulk.adaptiveLatencyEnabled'
  },
  maxTxPower: {
    format: 'a-gatewaysImport:bulk.maxTxPower',
    min: 0,
    max: 36
  },
  networkMaxDelayUp: {
    format: 'a-gatewaysImport:bulk.networkMaxDelayUp',
    min: 0,
    max: 15000
  },
  networkMaxDelayDown: {
    format: 'a-gatewaysImport:bulk.networkMaxDelayDown',
    min: 0,
    max: 15000
  },
  latitude: {
    format: 'a-gatewaysImport:bulk.latitude',
    min: -90,
    max: +90
  },
  longitude: {
    format: 'a-gatewaysImport:bulk.longitude',
    min: -180,
    max: +180
  },
  altitude: {
    format: 'a-gatewaysImport:bulk.altitude'
  }
}

// Export module
export default gatewayCsvHeaders
